import { CustomerServiceTag, QuoteApiModel, QuoteOptionApiModel } from '~/lib/api/smartsend/types';
import { P2GGrid } from '@parcel2go/core-ui';
import { QuoteResult } from '../QuoteResult';
import { CurrentSelectionType } from '../utils/CurrentSelectionType';
import { QuoteTagType } from '../utils/QuoteTagType';
import { QuoteLayoutVariant } from './QuoteLayoutVariant';

interface props {
  onSave?: (quote: QuoteApiModel, option: QuoteOptionApiModel) => void;
  quotes: QuoteApiModel[];
  currentSelection: CurrentSelectionType;
  estimatedValue?: number;
  quoteTagType: QuoteTagType;
  updateServiceTags: (add: CustomerServiceTag[], remove: CustomerServiceTag[]) => void;
  serviceTags: CustomerServiceTag[];
  toggleSpecificTag: (tag: CustomerServiceTag) => void;
  maxQuoteOptions: number;
  isXs: boolean;
  children?: React.ReactNode;
  variant: QuoteLayoutVariant;
}

export const QuoteLayoutSingleCourier: React.FC<props> = (props) => {
  if (props.quotes.length === 0) {
    return null;
  }

  return (
    <P2GGrid item md={4} xs={12}>
      {props.quotes.map((s, i) => (
        <QuoteResult
          variant={props.variant}
          isXs={props.isXs}
          maxQuoteOptions={props.maxQuoteOptions}
          toggleSpecificTag={props.toggleSpecificTag}
          index={i}
          key={s.Service.Id}
          updateServiceTags={props.updateServiceTags}
          quote={s}
          estimatedValue={props.estimatedValue}
          onSave={props.onSave}
          currentSelection={props.currentSelection}
          serviceTags={props.serviceTags.find((x) => x.ServiceSlug === s.Service.Id)?.Tags || []}
          editMode={props.quoteTagType}
        />
      ))}
    </P2GGrid>
  );
};
